module.exports = __webpack_public_path__ + "static/img/baoyu.da3a2116.png";